import axiosInstance from './http';

function logAndRethrow(endpoint, error) {
    if (error?.response) {
        console.error(`[contractApi] ${endpoint} -> ${error.response.status}`, {
            url: error.response.config?.url,
            method: error.response.config?.method,
            params: error.response.config?.params,
            data: error.response.data,
            headers: error.response.headers,
        });
    } else {
        console.error(`[contractApi] ${endpoint} -> network/error`, error);
    }
    throw error;
}

export default {
    async getContracts({ customer_id, facility_id, customer, facility, page = 1, page_size, q, status, ordering } = {}) {
        const params = {};
        if (page) params.page = page;
        if (page_size) params.page_size = page_size;
        if (customer_id ?? customer) params.customer = customer_id ?? customer;
        if (facility_id ?? facility) params.facility = facility_id ?? facility;
        if (q) params.q = q;                // поиск по номеру договора
        if (status) params.status = status; // ACTIVE | ARCHIVED | ...
        if (ordering) params.ordering = ordering;

        try {
            const response = await axiosInstance.get('contracts/', { params });
            return response.data; // { count, next, previous, results }
        } catch (error) {
            logAndRethrow('GET contracts/', error);
        }
    },
    async listByTarget({ target, id, page = 1, q } = {}) {
        if (!target || id == null) {
            return { count: 0, results: [] };
        }
        try {
            const response = await axiosInstance.get(`contracts/${target}/${id}/`, {
                params: {
                    page,
                    q: q || undefined,
                },
            });
            return response.data; // { count, next, previous, results }
        } catch (error) {
            logAndRethrow(`GET contracts/${target}/${id}/`, error);
        }
    },



    async getContract(id) {
        try {
            const response = await axiosInstance.get(`contracts/${id}/`);
            return response.data;
        } catch (error) {
            logAndRethrow(`GET contracts/${id}/`, error);
        }
    },
    async getContractDetail(id) {
        try {
            const response = await axiosInstance.get(`contracts/${id}/detail/`);
            return response.data;
        } catch (error) {
            logAndRethrow(`GET contracts/${id}/detail/`, error);
        }
    },
    // Получение следующего номера и даты договора
    async getNextNumber() {
        try {
            const response = await axiosInstance.get('contracts/next-number/');
            return response.data; // { sequence, date, number }
        } catch (error) {
            logAndRethrow('GET contracts/next-number/', error);
        }
    },

    // Создание договора
    async createContract(payload) {
        try {
            const response = await axiosInstance.post('contracts/create/', payload);
            return response.data; // ожидаем { id, ... }
        } catch (error) {
            logAndRethrow('POST contracts/create/', error);
        }
    },
    async updateContract(id, data) {
        try {
            const response = await axiosInstance.patch(`contracts/${id}/`, data);
            return response.data;
        } catch (error) {
            logAndRethrow(`PATCH contracts/${id}/`, error);
        }
    },
    async archiveContract(id) {
        try {
            const response = await axiosInstance.post(`contracts/${id}/archive/`);
            return response.data;
        } catch (error) {
            logAndRethrow(`POST contracts/${id}/archive/`, error);
        }
    },

    async deleteContract(id) {
        try {
            const response = await axiosInstance.delete(`contracts/${id}/`);
            return response.data;
        } catch (error) {
            logAndRethrow(`DELETE contracts/${id}/`, error);
        }
    },

    // POST /api/contracts/{id}/unarchive/ (разархивация)
    async unarchiveContract(id) {
        try {
            const response = await axiosInstance.post(`contracts/${id}/unarchive/`);
            return response.data;
        } catch (error) {
            logAndRethrow(`POST contracts/${id}/unarchive/`, error);
        }
    },

};
